import { useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'
import ComunicacaoService from '../services/comunicacao'

export const useInicializarUsuario = () => {
  const auth = useAuth()
  const inicializado = useRef(false)

  useEffect(() => {
    if (!auth.isAuthenticated || inicializado.current) return
    inicializado.current = true
    // HU-021: Garante que o usuario existe em SGOF_USUARIOS_DETALHES
    ComunicacaoService.inicializarUsuario().catch(() => {
      // Silencioso — nao bloqueia o acesso ao sistema
    })
  }, [auth.isAuthenticated])
}

export default useInicializarUsuario
